export const findSectionLevelPercentage = async (data: any) => {
  try {
    const sectionLevelPercentage: number[] = []
    let allItemsGreaterThan30: boolean = true
    await data.forEach(async (item: any) => {
      // console.log(item, 'form find sectin level percentage')
      let percentage = Math.round((await (parseInt(item?.totalMarkObtained) / parseInt(item?.totalMark))) * 100)
      sectionLevelPercentage.push(percentage)
    })

    for (let i = 0; i < sectionLevelPercentage.length; i++) {
      if (sectionLevelPercentage[i] < 30) {
        allItemsGreaterThan30 = false
        break
      }
    }

    return { sectionLevelPercentage, allItemsGreaterThan30 }
  } catch (err) {
    console.log(err, 'err while finding section level percentage')
  }
}
